import { useCallback, useLayoutEffect, useState } from "react"
import { RecurrenceBodyProps, RecurrenceDetail } from "./types"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { scheduleServiceFetch } from "../../../../utils/constants/callService"
import { QuestionnaireProps } from "../../../../components/headerQuestionnaire/types"
import dayjs from "dayjs"
import { Constants } from "../../../../utils/constants"
import { Comments } from "./components/listDetail/types"
import { useEvent } from "../../../../hooks/emitter"
import { Events } from "../../../../hooks/emitter/types"
import { actions } from "../detail/components/answer/contants"
import { navigateOption, transform, transformScedule } from "./constanst"
import { SnackbarFormat } from "../../../../utils/types/generals"

const RecurrenceBody = ({ children }: RecurrenceBodyProps) => {
    const { id } = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const [questionnaireData, setQuestionnaireData] = useState<QuestionnaireProps>()
    const [recurrencesList, setRecurrenceList] = useState<RecurrenceDetail>()
    const [isLoading, setIsLoading] = useState(false)
    const [ids, setIds] = useState<{ actionPlan: string; reportFolio: string | number }>()
    const [snackbar, setSnackbar] = useState<SnackbarFormat>()

    const getRecurenceById = useCallback(async () => {
        if (!id) { return }
        setIsLoading(true)
        const response = await scheduleServiceFetch.getRecurrenceById({ id })
        setIsLoading(false)
        if (!response.errors) {
            setIds({
                actionPlan: response.actionPlanImplementedId ?? '',
                reportFolio: response?.reportFoliosIds ?? ''
            })
            const item = response.questionnaireDetail?.answers?.find(item => item.selected)
            setQuestionnaireData({
                title: response.questionnaireDetail?.questionnaire ?? '',
                question: response.questionnaireDetail?.question ?? '',
                item: item?.title,
                amountRecurrencesCreated: response.amountRecurrencesCreated || 1,
                answerList: response.questionnaireDetail?.answers?.filter(answer => !!answer.selected).map(answer => ({
                    label: answer.title ?? ''
                })) || []
            })

            setRecurrenceList({
                answer: response.questionnaireDetail?.question ?? '',
                item: item?.title ?? '',
                date: dayjs(response.updateTime).locale('es').format(Constants.dayjsFormat),
                currenceRecurrence: {
                    title: '',
                    itemList: response.recurrenceComment?.map(comment => {
                        const userName = `${comment.user?.firstName ?? ''} ${comment.user?.lastName ?? ''}`.trim()
                        const role = comment.user?.role?.description
                        return ({
                            id: comment.id?.toString() ?? '',
                            amount: String(comment.recurrenceCommentChild?.length ?? 0),
                            date: dayjs(comment.createTime).locale('es').format(Constants.dayjsFormat),
                            user: `${userName} - ${role}`,
                            label: comment.comment ?? '',
                            evidence: response.evidences,
                            comments: comment.recurrenceCommentChild?.map(commentChild => {
                                const userName = `${commentChild.user?.firstName ?? ''} ${commentChild.user?.lastName ?? ''}`.trim()
                                const role = commentChild.user?.role?.description
                                const comment: Comments = {
                                    comment: commentChild.comment ?? '',
                                    date: dayjs(commentChild.createTime).locale('es').format(Constants.dayjsFormat),
                                    user: `${userName} - ${role}`,
                                    answers: [],
                                }
                                return comment
                            }) || []
                        })
                    })
                },
                historyRecurrence: {
                    title: '',
                    itemList: response.lastThreeRecurrences?.map(comment => {
                        const lastRecurrence = comment?.recurrenceComment?.[0]
                        const userName = `${comment?.userAssign?.firstName ?? ''} ${comment?.userAssign?.lastName ?? ''}`.trim()
                        const role = comment?.userAssign?.role?.description
                        return ({
                            id: comment.id?.toString() ?? '',
                            amount: String(comment.recurrenceComment?.length ?? 0),
                            date: dayjs(lastRecurrence?.createTime || comment?.createTime).locale('es').format(Constants.dayjsFormat),
                            user: `${userName} - ${role}`,
                            label: lastRecurrence?.comment ?? '',
                            evidence: comment.evidences,
                            comments: comment.recurrenceComment?.map(commentChild => {
                                const userName = `${commentChild.user?.firstName ?? ''} ${commentChild.user?.lastName ?? ''}`.trim()
                                const role = commentChild.user?.role?.description
                                const comment: Comments = {
                                    id: commentChild.id?.toString() ?? null,
                                    comment: commentChild.comment ?? '',
                                    date: dayjs(commentChild.createTime).locale('es').format(Constants.dayjsFormat),
                                    user: `${userName} - ${role}`,
                                    answers: commentChild?.recurrenceCommentChild?.map(child => {
                                        const userName = `${child.user?.firstName ?? ''} ${child.user?.lastName ?? ''}`.trim()
                                        const role = child.user?.role?.description

                                        return ({
                                            comment: child.comment ?? '',
                                            date: dayjs(child.createTime).locale('es').format(Constants.dayjsFormat),
                                            user: `${userName} - ${role}`,
                                        })
                                    }),
                                }
                                return comment
                            }) || []
                        })
                    })
                }
            })
            return
        }
    }, [id])
    const goReportFolioOrActionPlan = ({ name, id: localeId }: { name: 'action-plan' | 'report-folio'; id?: string | number }) => {
        const locationArray = location.pathname.split('/')
        const navigateType = locationArray[2]
        const tansformed = transform?.[navigateType]
        if (tansformed) {
            const scheduleId = location?.state?.id
            const navigationType = navigateOption[tansformed]
            let nav = `${navigationType.reportFolio}`
            if (name == 'action-plan') { nav = `${navigationType.actionPlan}/${localeId}` }
            navigate(`${nav}?${navigationType.navigate.replace('{id}', scheduleId).replace('{recurence_id}', id ?? '')}&${actions}&id=${localeId}`, {
                state: {
                    type: transformScedule[navigateType],
                    ...questionnaireData,
                    id: id,
                    replaceRoutes: {
                        search: {
                            search: location.search,
                            state: location.state
                        }
                    }
                }
            })
        }
    }

    const closeSnackbar = () => {
        setSnackbar(undefined)
    }
    useEvent({ eventName: Events.comment, callback: () => { getRecurenceById() } })
    // useEvent({ eventName: Events.snackbar, callback: (payload) => { setSnackbar(payload) } })

    useLayoutEffect(() => {
        getRecurenceById()
    }, [getRecurenceById])
    return children({ questionnaireData, isLoading, recurrencesList, ids, snackbar, closeSnackbar, goReportFolioOrActionPlan })
}

export { RecurrenceBody }